// @flow

import { serialize } from 'object-to-formdata';
import { hpfetch, hpfetchWithoutContentType } from '../util';
import type { wrappedApiResponseType } from '../apiTypes';
import type { profileType, locationType, profileFlagType } from '../../types';

export const get = (): Promise<wrappedApiResponseType<profileType>> =>
  hpfetch('profile/');

export const updateProfile = (fields: any) =>
  hpfetchWithoutContentType('profile/', {
    body: serialize(fields),
    method: 'PUT',
  });

export const partialUpdateProfile = (fields: any) =>
  hpfetchWithoutContentType('profile/', {
    body: serialize(fields),
    method: 'PATCH',
  });

export const partialUpdateProfileJson = (fields: any) =>
  hpfetch('profile/', {
    method: 'PATCH',
    body: JSON.stringify(fields),
  });

export const updateProfilePhoto = (image: any, fileName: string) => {
  const formData = serialize({});
  formData.append('image', image, fileName);

  return hpfetchWithoutContentType('profile/', {
    body: formData,
    method: 'PATCH',
  });
};

export const sendValidationPin = () =>
  hpfetch('profile/send_validation_pin/', {
    method: 'PUT',
  });

export const validatePhoneNumber = (pin: string) =>
  hpfetch('profile/validate_phone_number/', {
    method: 'PUT',
    body: JSON.stringify({
      pin,
    }),
  });

export const setPreferredAccount = (accountId: number) =>
  hpfetch('profile', {
    method: 'PATCH',
    body: JSON.stringify({
      payment_method: accountId,
    }),
  });

export const setDefaultLocation = (
  default_location: locationType,
  use_default_location: boolean,
) =>
  hpfetch('profile/', {
    method: 'PATCH',
    body: JSON.stringify({
      default_location,
      use_default_location,
    }),
  });

export const setUseDefaultLocation = (use_default_location: boolean) =>
  hpfetch('profile/', {
    method: 'PATCH',
    body: JSON.stringify({
      use_default_location,
    }),
  });

export const deactivate = () =>
  hpfetch('profile/', {
    method: 'DELETE',
  });

export const getFlags = (): Promise<
  wrappedApiResponseType<Array<profileFlagType>>,
> => hpfetch(`profile/flags/`);

export const setFlag = (fields: any) =>
  hpfetchWithoutContentType('profile/flags/', {
    body: serialize(fields),
    method: 'POST',
  });
